<template>
  <div>
    <template v-for="(item, index) in vasItems" :key="index">
      <ServiceItem
        :item="item"
        :view-mode="viewMode"
        @remove="() => $emit('remove', index)"
      />
    </template>

    <PBtn
      v-if="!viewMode"
      dense
      flat
      text
      class="text-sm"
      @click="$emit('add')"
    >
      <AddIcon class="icon--sm q-mr-xxs" />
      <span>Add Service Fee </span>
    </PBtn>

    <q-separator v-if="vasItems.length || !viewMode" spaced />
  </div>
</template>

<script setup>
import AddIcon from "assets/icons/add.svg";

defineEmits(["add", "remove"]);

defineProps({
  vasItems: {
    type: Array,
    default: () => {
      return [];
    },
  },

  viewMode: {
    type: Boolean,
    default: false,
  },
});
</script>
